module.exports = __webpack_public_path__ + "static/media/logout.6799b15d.svg";